import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { DEFAULT_AFTER_LOGIN, loginPathFor } from '../utils/authRedirect';

// The guard for every signed-in route. Used as a layout route in App.js
// (`<Route element={<ProtectedRoute …/>}>…</Route>`), so the routes it guards are always
// declared: they used to be rendered only once Redux said `authenticated`, which on a fresh
// load of any deep URL meant no route matched at all and the page stayed blank — for good,
// when there was no session to verify.
//
// `isSessionVerifying` is App.js's own state for its one `verifyBusinessToken` call on load;
// until it settles, Redux cannot say yet whether the person is signed in, so redirecting then
// would send someone with a valid session to the login.
//
// `requireClientType` is the Cierres block's extra condition (see App.js): a signed-in
// business of another type is sent to its own backoffice rather than shown nothing.

function ProtectedRoute({
  authenticated,
  isBusiness,
  mantisBusiness,
  isSessionVerifying,
  requireClientType,
  children,
}) {
  const location = useLocation();

  if (isSessionVerifying) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="max-w-md mx-auto text-center p-8 bg-white rounded shadow-lg">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Verificando sesión...
          </h2>
          <p className="text-gray-600 mb-4">
            Por favor espera mientras verificamos tu sesión.
          </p>
        </div>
      </div>
    );
  }

  if (!authenticated || !isBusiness) {
    return <Navigate to={loginPathFor(location)} replace />;
  }

  if (requireClientType && mantisBusiness?.clientType !== requireClientType) {
    return <Navigate to={DEFAULT_AFTER_LOGIN} replace />;
  }

  return children ?? <Outlet />;
}

const mapStateToProps = (state) => ({
  authenticated: state.auth.authenticated,
  isBusiness: state.auth.isBusiness,
  mantisBusiness: state.auth.mantisBusiness,
});

export default connect(mapStateToProps)(ProtectedRoute);
